import { setWebBridge } from "./webBridge";
import { getStorage } from "../utils/storage";
// import queryString from "querystring";

// 해당 TFbEventName, TApiName은 Firebase 데이터와 관련이 있기에 수정시 내용 공유가 있어야 합니다.
export type TFbEventName =
  | "connection"
  | "select_category"
  | "home_select_project"
  | "search_select_project"
  | "hashtag_select_project"
  | "search_recent"
  | "detail_download"
  | "detail_share"
  | "detail_like"
  | "detail_unlike"
  | "detail_hashtag"
  | "detail_app_update"
  | "search_keyword"
  | "detail_more"
  | "click_home"
  | "click_back"
  | "close"
  | "detail_preview_video"
  | "detail_swipe"
  | "update_cancel"
  | "logEvent";

type TApiName =
  | "getToken"
  | "getCategories"
  | "getCategoriesNewCheck"
  | "getProjects"
  | "getHashTags"
  | "getProjectDetail"
  | "updateDownloadCount"
  | "addLikeCount"
  | "deleteLikeCount";

export const firebaseEvent = (event_type: TFbEventName, jsonParams?: {}) => {
  const args = JSON.stringify({
    name: "wv_pds",
    event_type,
    ...jsonParams,
  });

  // console.log(args);

  if (event_type === "logEvent") {
    return;
  }
  setWebBridge({
    name: "logEvent",
    args,
  });
};
export type TApiType = "start" | "end" | "error";
export interface TFbApiEvent {
  name: TApiName | string;
  params: any;
  type: TApiType;
  method: String;
}
// export const fbApiEvent = (props: TFbApiEvent) => {
//   const query: any = getStorage("kine_app");
//   const { clientId } = queryString.parse(query);
//   const date = new Date().getTime();
//   const jsonParams = {
//     client_id: clientId,
//     api_name: props.name,
//     timestamp: date,
//     request_params: props.params,
//     method_type: props.method,
//   };

//   let eventName = "wv_pds_backend_api_start";
//   if (props.type === "start") {
//     eventName = "wv_pds_backend_api_start";
//   } else if (props.type === "end") {
//     eventName = "wv_pds_backend_api_end";
//   } else if (props.type === "error") {
//     eventName = "wv_pds_backend_api_error";
//   }

//   firebaseEvent(eventName, jsonParams);
// };

export const screenType = () => {
  const locationPathArr = window.location.pathname.split("/");
  let type;

  if (locationPathArr[1] === "search" && locationPathArr[2] !== undefined) {
    type = "search_list";
  } else if (
    locationPathArr[1] === "search" &&
    locationPathArr[2] === undefined
  ) {
    type = "search";
  } else if (locationPathArr[1] === "detail") {
    type = "detail";
  } else {
    type = "home";
  }
  return type;
};

export const accessType = () => {
  const { pathname } = window.location;
  let access_type;
  if (pathname === "/" || pathname === "/feeds") {
    access_type = "home";
  } else if (pathname.indexOf("search") !== -1) {
    access_type = "search";
  } else if (pathname.indexOf("detail") !== -1) {
    access_type = "detail";
  } else if (
    pathname.indexOf("/feeds") !== -1 &&
    pathname.split("/").length === 3
  ) {
    access_type = "category";
  }
  return access_type;
};

export const getSelectProjectType = () => {
  const type =
    window.location.pathname.indexOf("search") !== -1
      ? getStorage("select_type")
      : "home";
  return type;
};

export default firebaseEvent;
